module.exports = __webpack_public_path__ + "img/img_index_cha_02_1@2x.3f7806a0.png";